import AppTitle from '@theme/components/atom/AppTitle'
import Breadcrumbs from '@theme/components/molecule/Breadcrumbs'
import ImageUrlMixin from '~/mixins/ImageUrlMixin'
import LayoutBase from '@theme/components/shop/LayoutBase'
import ProductsVisited from '@theme/components/product/ProductsVisited/ProductsVisitedLazy'
import SeoMixin from '~/mixins/SeoMixin'
import UniqueSellingPoints from '@theme/components/shop/UniqueSellingPoints'
import Wysiwyg from '@theme/components/utils/Wysiwyg'

export default {
  components: {
    AppTitle,
    Breadcrumbs,
    LayoutBase,
    ProductsVisited,
    UniqueSellingPoints,
    Wysiwyg,
  },
  props: {
    terms: {
      type: Array,
    },
    letters: {
      type: Array,
    },
  },
  computed: {
    breadcrumbs() {
      const breadcrumbs = [
        {
          title: this.$t('PageTermsList.breadcrumbs.index'),
          path: this.$route.path,
        },
      ]
      if (this.selectedLetter) {
        breadcrumbs.push({
          title: this.selectedLetter.toUpperCase(),
          path: this.localePath({ name: 'term', query: this.selectedLetter }),
        })
      }
      return breadcrumbs
    },
    selectedLetter() {
      return this.$route.query.l
    },
    termsByLetter() {
      const byLetter = {}
      this.letters.forEach(letter => (byLetter[letter] = []))

      this.terms &&
        this.terms.filter(term => term.title).forEach(term => {
          const firstLetter = term.title[0].toLowerCase()
          if (term.title && byLetter[firstLetter]) {
            byLetter[firstLetter].push(term)
          }
        })

      this.letters.forEach(letter => {
        byLetter[letter].sort((a, b) => {
          return a.title.localeCompare(b.title)
        })
      })

      return byLetter
    },
  },
  head() {
    return this.getSeoHead({ yamlKey: 'PageTermsList' })
  },
  methods: {
    selectLetter(e, letter) {
      if (!e.metaKey) {
        e.stopPropagation()
        e.preventDefault()
        this.$router.push({ path: this.$router.path, query: { l: letter } })
      }
    },
  },
  mixins: [ImageUrlMixin, SeoMixin],
}
